'use client'

import Image from 'next/image'
import { useElementVisible } from '@hooks/useElementVisible'
import { AwardsMock } from '@components/AboutUs/AboutUsMock'
import styles from './Awards.module.scss'

const Awards = () => {
  const containerSection = useElementVisible({ threshold: 0.2 })
  const textSection = useElementVisible({ threshold: 1 })
  if (!AwardsMock) return null

  return (
    <div className={styles.wrapper}>
      <div ref={textSection.ref} className={`${styles.textContainer} ${textSection.isVisible ? styles.visible : ''}`}>
        <span className={styles.capitalText}>{AwardsMock?.description}</span>
        <span className={styles.heading}>{AwardsMock?.title}</span>
      </div>
      <div
        ref={containerSection.ref}
        className={`${styles.container} ${containerSection.isVisible ? styles.animate : ''}`}>
        <div className={styles.curveBase} />
        {AwardsMock?.awards?.map((award, index) => (
          <Image
            key={index}
            src={award.src}
            alt={award.alt}
            width={200}
            height={250}
            className={`${styles.image} ${styles[award.position]}`}
          />
        ))}
      </div>
    </div>
  )
}

export default Awards
